/**********************************************
  EXPANDERS EXPLAINED:

  Take a route from of the sitemap generation process,
  return a promise for thenable routes - to be flattened when the sitemap is generated

*//////////////////////////////////////////////

import logger from 'logger';
import config from "config";
import ApiClient from "utils/ApiClient";

import { isInThePast } from "utils/LocalDateTimeHelper";
import { nDayArrFactoryBoth } from "utils/sitemapUtils";

import { toSlug } from 'utils';
import { getMonths } from 'modules/Football/utils';

const client = new ApiClient();

export function fixturesResultsExpander({url, sitemap: { changefreq, priority }}) {
  const routeArray = [];
  const dateArray = nDayArrFactoryBoth();

  return new Promise(resolve => {
    for (const date of dateArray) {
      routeArray.push({ url: url.replace(":date", date), sitemap: {changefreq, priority}});
    }
    return resolve(routeArray);
  });
}

export function matchExpander({url, sitemap: { changefreq, priority }}) {
  const routeArray = [];
  const dateArray = nDayArrFactoryBoth();

  const promiseStack = [];

  for (const date of dateArray) {
    promiseStack.push(
      client.get(config.api.football.dailyMatches, {params: {match_date: date}})
        .then(result => result)
        .catch(err => {
          logger.debug(err);
          return [];
        })
    );
  }

  return Promise.all(promiseStack)
    .then(results => {
      for (const res of results) {
        for (const {match_reference: { id }, match_date: matchDateTime} of res) {
          const isInPast = isInThePast(matchDateTime);
          // NB: Could add last modified here
          routeArray.push({
            url: url.replace(":matchId", id),
            sitemap: {
              changefreq,
              priority,
              lastmodISO: isInPast ? matchDateTime : undefined
            }
          });
        }
      }
      return routeArray;
    });
}

export function leagueExpander({url, sitemap: { changefreq, priority }}) {
  return client.get(config.api.football.competitionList).then(list => list
    .filter(c => c.show_tables)
    .map(comp => ({
      url: url
        .replace(":name", toSlug(comp.name))
        .replace(":competition", comp.competition_reference.id),
      sitemap: {
        changefreq,
        priority
      }
    }))
  );
}

export function competitionExpander({url, sitemap: {changefreq, priority}}) {
  return client.get(config.api.football.competitionList).then(list => list.map(comp => ({
      url: url
        .replace(":compName", toSlug(comp.name))
        .replace(":compId", comp.competition_reference.id),
      sitemap: {
        changefreq,
        priority
      }
    }))
  );
}

export function competitionMonthExpander({url, sitemap: {changefreq, priority, fixturesResults}}) {
  return client.get(config.api.football.competitionList).then(list =>
    Promise.all(list.map(comp => client.get(`${config.api.football.competitions}/${comp.competition_reference.id}`).catch(() => Promise.resolve())))
  )
  .then((competitions = []) => {
    const entries = competitions.map(comp => comp && getMonths(comp.season_start_date, comp.season_end_date, fixturesResults)
      .map(month => ({
        url: url
          .replace(":compName", toSlug(comp.name))
          .replace(":compId", comp.competition_reference.id)
          .replace(":month", month),
        sitemap: {
          changefreq,
          priority
        }
      }))
    );

    return entries.filter(i => i).reduce((a , b) => a.concat(b));
  });
}



// WEBPACK FOOTER //
// ./modules/Football/sitemap-helper.js